{
  "valid": "Galioja"
}
